import { useEffect, useState } from "react";

// ui
import { Box, Alert, Typography, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

// Table
import TableTopBar from "../component/TableTopBar";
import { ConstTable } from "../component/Table";
import { EmptyState } from "../component/EmptyState";
import { DataDetailTable } from "../component/detail/DataDetailTable";

// Bar
import { SerchSideBar } from "../component/SerchSideBar";

// Modal
import { DataEditModal } from "../component/DataEditModal";
import { DataAddModal } from "../component/DataAddModal";
import { DataAddModalResult } from "../component/DataAddModalResult";
import { DataDeleteModal } from "../component/tableFunction/DataDeleteModal";

// jotai
import { useAtomValue, useSetAtom } from "jotai";
import { AppAtoms } from "../lib/store";

// API
import {
  getScreenColumnConfigs,
  postScreenColumnConfig,
  deleteScreenColumnConfig,
} from "../api/screenColumnConfig";
import {
  getScreenColumnConfigLoginCompanys,
  postScreenColumnConfigLoginCompanys,
} from "../api/screenColumnConfigLoginCompany";
import {
  getScreenColumnConfigSelects,
  postScreenColumnConfigSelects,
} from "../api/screenColumnConfigSelect";
import {
  getSerchHighRankCompanys,
  getSerchCategorys,
  getSerchSaleCompanys,
  getSerchProducts,
} from "../api/serch";
import { getScreenColumns } from "../api/screenColumn";

// InterFace
import { screenColumnConfigTableColumn } from "../config/screenColumnConfig";
import {
  dataDifine,
  subDataDifine,
  EditDataDifine,
} from "../config/dataInterface";

// OtherFunc
import { getFirstYear, getOneYear } from "../lib/other";
import { CONST } from "../config/const";

function ScreenColumnConfig() {
  const setIsLoading = useSetAtom(AppAtoms.isLoading);
  const isSmartPhone = useAtomValue(AppAtoms.isSmartPhone);
  const loginUser = useAtomValue(AppAtoms.loginUser);
  const setContractScreenColumn = useSetAtom(AppAtoms.contractScreenColumn);
  const setTossUpScreenColumn = useSetAtom(AppAtoms.tossUpScreenColumn);
  const setDetailBreadcrumb = useSetAtom(AppAtoms.detailBreadcrumb);
  const [detailView, setDetailView] = useState<boolean>(false);
  const [sortColumn, setSortColumn] = useState<{ key: string; sort: string }[]>(
    [],
  );
  const [dataDetail, setDataDetail] = useState<{
    [key: string]: number | string | { [key: string]: string | number }[];
  } | null>(null);

  // 各権限毎のヘッダーメニューの編集
  const addDataTypes: { auth: string[]; name: string }[] = [
    {
      auth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      name: "システム項目設定登録",
    },
  ];
  const addCSVDataTypes: { auth: string[]; name: string }[] = [];
  const getXLSXDataTypes: { auth: string[]; name: string }[] = [];
  const editDatasTypes: { auth: string[]; name: string }[] = [];

  const [addDataNames, setAddDataNames] = useState<string[]>([]);
  const [addDataName, setAddDataName] = useState<string>("");
  const [addCSVDataNames, setAddCSVDataNames] = useState<string[]>([]);
  const [addCSVDataName, setAddCSVDataName] = useState<string>("");
  const [getXLSXDataNames, setGetXLSXDataNames] = useState<string[]>([]);
  const [getXLSXDataName, setGetXLSXDataName] = useState<string>("");
  const [editDatasNames, setEditDatasNames] = useState<string[]>([]);
  const [editDatasName, setEditDatasName] = useState<string>("");

  useEffect(() => {
    let addDataNames: string[] = [];
    let addCSVDataNames: string[] = [];
    let getXLSXDataNames: string[] = [];
    let editDatasNames: string[] = [];
    addDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        addDataNames.push(dataType.name);
      }
    });
    setAddDataNames(addDataNames);
    addCSVDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        addCSVDataNames.push(dataType.name);
      }
    });
    setAddCSVDataNames(addCSVDataNames);
    getXLSXDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        getXLSXDataNames.push(dataType.name);
      }
    });
    setGetXLSXDataNames(getXLSXDataNames);
    editDatasTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        editDatasNames.push(dataType.name);
      }
    });
    setEditDatasNames(editDatasNames);
  }, [loginUser]);

  useEffect(() => {
    if (addDataName === "システム項目設定登録") {
      setAddModal(true);
    }
  }, [addDataName]);

  useEffect(() => {}, [addCSVDataName]);

  // サブテーブルデータの一覧取得
  const [getSubTableName, setGetSubTableName] = useState<{
    name: string;
    key: { [key: string]: string };
    subData: subDataDifine[];
  }>({
    name: "",
    key: {},
    subData: [],
  });
  useEffect(() => {
    if (getSubTableName.name === "ログインパートナー一覧") {
      getSubtableDataLoginCompany();
    }
    if (getSubTableName.name === "選択肢一覧") {
      getSubtableDataSelect();
    }
  }, [getSubTableName.name, getSubTableName.key]);

  // サブテーブルデータの詳細取得
  const [getSubTableDetail, setGetSubTableDetail] = useState<{
    name: string;
    key: { [key: string]: string };
    dataDetail: {
      [key: string]:
        | number
        | string
        | { [key: string]: string | number }[]
        | { [key: string]: string | string[] };
    } | null;
  }>({
    name: "",
    key: {},
    dataDetail: null,
  });
  useEffect(() => {}, [getSubTableDetail.name, getSubTableDetail.key]);

  // サブテーブルデータの登録
  const [getSubTableAdd, setGetSubTableAdd] = useState<{
    name: string;
    row: dataDifine | null;
  }>({
    name: "",
    row: null,
  });
  useEffect(() => {
    if (getSubTableAdd.name === "ログインパートナー追加") {
      openModalSubtableDataAddLoginCompany();
    }
    if (getSubTableAdd.name === "選択肢追加") {
      openModalSubtableDataAddSelect();
    }
  }, [getSubTableAdd.name, getSubTableAdd.row]);

  // サブサブテーブルデータの一覧取得
  const [getSubSubTableName, setGetSubSubTableName] = useState<{
    name: string;
    key: { [key: string]: string };
    subData: subDataDifine[];
  }>({
    name: "",
    key: {},
    subData: [],
  });
  useEffect(() => {}, [getSubSubTableName.name, getSubSubTableName.key]);

  // サブテーブルデータの登録
  const [getSubSubTableAdd, setGetSubSubTableAdd] = useState<{
    name: string;
    row: dataDifine | null;
  }>({
    name: "",
    row: null,
  });
  useEffect(() => {}, [getSubSubTableAdd.name, getSubSubTableAdd.row]);

  const [tableOriginalFunc, setTableOriginalFunc] = useState<{
    name: string;
    key: { [key: string]: string };
  }>({
    name: "",
    key: {},
  });
  useEffect(() => {
    if (tableOriginalFunc.name === "項目削除") {
      setDeleteDataInf({
        status: "open",
        key: tableOriginalFunc.key,
        message: "",
      });
    }
  }, [tableOriginalFunc.name, tableOriginalFunc.key]);

  const [serchOpen, setSerchOpen] = useState(false);
  const aiChatOpen = useAtomValue(AppAtoms.aiChatOpen);
  const setAiChatOpenAtom = useSetAtom(AppAtoms.aiChatOpen);

  const firstYear = getFirstYear();
  const { thisYear, thisMonth, lastYear, lastMonth } = getOneYear();

  // 表示数・ページ
  const [displayNumber, setDisplayNumber] = useState(50);
  const displayNumbers = [25, 50, 100, 250, 500];
  const [pageNumber, setPageNumber] = useState(1);
  const [maxPageNumber, setMaxPageNumber] = useState(1);

  // 検索項目
  const serchColumn = screenColumnConfigTableColumn.dataColumn.reduce(
    (column, difine) => {
      if (difine.serch === true) {
        if (difine.serchType === "date") {
          return {
            ...column,
            [difine.key + "_start"]: "",
            [difine.key + "_end"]: "",
            no_entry_flg: "通常",
          };
        } else if (difine.serchType === "payment_year_month") {
          return {
            ...column,
            payment_year: thisYear.toString(),
            payment_month: thisMonth.toString(),
            no_entry_flg: "通常",
          };
        } else {
          return {
            ...column,
            [difine.key]: "",
            no_entry_flg: "通常",
          };
        }
      } else {
        return {
          ...column,
          no_entry_flg: "通常",
        };
      }
    },
    {},
  );
  const [serchString, setSerchString] = useState(serchColumn);
  const [serchStringView, setSerchStringView] = useState(serchColumn);

  // テーブルデータ
  const [fetchData, setFetchData] = useState<dataDifine[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  async function getTableData(edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const fetchData = await getScreenColumnConfigs({
      ...serchString,
      displayNumber,
      pageNumber,
    });
    if (fetchData === null) {
      setFetchData([]);
      setTotalCount(0);
      setMaxPageNumber(1);
      setPageNumber(1);
    } else if (fetchData) {
      setFetchData(fetchData.screenColumnConfigs);
      const countScreenColumnConfigs = Number(
        fetchData.countScreenColumnConfigs,
      );
      setTotalCount(countScreenColumnConfigs);
      setMaxPageNumber(Math.ceil(countScreenColumnConfigs / displayNumber));
    }
    if (!edit) {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    getTableData(false);
  }, [serchString, displayNumber, pageNumber]);

  function closeDetailView() {
    setDetailView(false);
    setDataDetail(null);
    setDetailBreadcrumb(null);
  }

  function getDataDetail(key: { [key: string]: string }, edit: boolean) {
    const row = fetchData.find((r) => String(r.id) === String(key.id));
    if (row) {
      setDataDetail(
        row as {
          [key: string]: number | string | { [key: string]: string | number }[];
        },
      );
      if (!edit) {
        setDetailView(true);
        setDetailBreadcrumb({
          crumb: "システム設定 / 画面項目設定 / ",
          title: "画面項目設定詳細",
        });
      }
    }
  }

  // 商材新規作成
  const addDataColumns = screenColumnConfigTableColumn.dataColumn.reduce(
    (column, difine) => {
      if (difine.add) {
        if (difine.key === "screen_column_selects") {
          return {
            ...column,
            [difine.key]: [""],
          };
        } else {
          return {
            ...column,
            [difine.key]: "",
          };
        }
      } else {
        return {
          ...column,
        };
      }
    },
    {},
  );
  const [onDataAddModalResult, setOnDataAddModalResult] = useState("");
  const [addData, setAddData] = useState<{
    [key: string]: string | boolean | any[];
  }>(addDataColumns);
  const [onAddModal, setAddModal] = useState(false);

  async function postAddData() {
    setIsLoading(true);
    setAddModal(false);
    const postResponce = await postScreenColumnConfig(addData);
    if (postResponce === "success") {
      await getTableData(true);
      const { contractScreenColumn, tossUpScreenColumn } =
        await getScreenColumns();
      setContractScreenColumn(contractScreenColumn);
      setTossUpScreenColumn(tossUpScreenColumn);
      setAddData(addDataColumns);
      setOnDataAddModalResult("success");
    } else {
      setAddModal(true);
      setOnDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // データ項目削除
  const [deleteDataInf, setDeleteDataInf] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  }>({
    status: null,
    key: {},
    message: "",
  });
  async function deleteData() {
    setDeleteDataInf({
      ...deleteDataInf,
      status: "loading",
    });
    const id = deleteDataInf.key.id;
    const responce = await deleteScreenColumnConfig(id);
    if (responce == "success") {
      await getTableData(false);
      setDeleteDataInf({
        ...deleteDataInf,
        status: "success",
      });
    } else {
      setDeleteDataInf({
        ...deleteDataInf,
        status: "failed",
        message: responce,
      });
    }
  }
  useEffect(() => {
    if (deleteDataInf.status === "loading") {
      setIsLoading(true);
    } else if (deleteDataInf.status !== null) {
      setIsLoading(false);
    }
  }, [deleteDataInf]);

  // サブテーブルデータの登録結果（共通）
  const [onSubtableDataAddModalResult, setOnSubtableDataAddModalResult] =
    useState("");

  // ログインパートナー一覧取得
  async function getSubtableDataLoginCompany() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getScreenColumnConfigLoginCompanys(
        getSubTableName.key.id,
      );
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // ログインパートナー登録
  const [addDataLoginCompany, setAddDataLoginCompany] = useState<{
    [key: string]: string | boolean | any[];
  }>({
    screen_column_id: "",
    all_login_sale_company: [],
    select_login_sale_company: [],
  });
  const [onDataAddModalLoginCompany, setOnDataAddModalLoginCompany] =
    useState(false);
  async function openModalSubtableDataAddLoginCompany() {
    if (getSubTableAdd.row) {
      setIsLoading(true);
      const fetchData = await getScreenColumnConfigLoginCompanys(
        getSubTableAdd.row.id as string,
      );
      setAddDataLoginCompany({
        screen_column_id: getSubTableAdd.row.id as string,
        all_login_sale_company: fetchData.entry_sale_company_datas,
        select_login_sale_company: fetchData.sudDatas,
      });
      setOnDataAddModalLoginCompany(true);
      setIsLoading(false);
    }
  }
  async function postAddDataLoginCompany() {
    setIsLoading(true);
    setOnDataAddModalLoginCompany(false);
    const postResponce =
      await postScreenColumnConfigLoginCompanys(addDataLoginCompany);
    if (postResponce === "success") {
      if (getSubTableName.name == "ログインパートナー一覧") {
        await getSubtableDataLoginCompany();
      }
      setIsLoading(true);
      await getTableData(true);
      setAddDataLoginCompany({
        screen_column_id: "",
        all_login_sale_company: [],
        select_login_sale_company: [],
      });
      setOnSubtableDataAddModalResult("success");
    } else {
      setOnDataAddModalLoginCompany(true);
      setOnSubtableDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // 選択肢一覧取得
  async function getSubtableDataSelect() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getScreenColumnConfigSelects(
        getSubTableName.key.id,
      );
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // 選択肢登録
  const [addDataSelect, setAddDataSelect] = useState<{
    [key: string]: string | boolean | any[];
  }>({
    screen_column_id: "",
    screen_column_selects: [],
  });
  const [onDataAddModalSelect, setOnDataAddModalSelect] = useState(false);
  async function openModalSubtableDataAddSelect() {
    if (getSubTableAdd.row) {
      setIsLoading(true);
      const fetchData = await getScreenColumnConfigSelects(
        getSubTableAdd.row.id as string,
      );
      setAddDataSelect({
        screen_column_id: getSubTableAdd.row.id as string,
        screen_column_selects:
          fetchData.sudDatas.length === 0
            ? [
                {
                  id: 0,
                  screen_column_select: "",
                },
              ]
            : fetchData.sudDatas,
      });
      setOnDataAddModalSelect(true);
      setIsLoading(false);
    }
  }
  async function postAddDataSelect() {
    setIsLoading(true);
    setOnDataAddModalSelect(false);
    const postResponce = await postScreenColumnConfigSelects(addDataSelect);
    if (postResponce === "success") {
      if (getSubTableName.name == "選択肢一覧") {
        await getSubtableDataSelect();
      }
      setIsLoading(true);
      await getTableData(true);
      setAddDataSelect({
        screen_column_id: "",
        screen_column_selects: [],
      });
      setOnSubtableDataAddModalResult("success");
    } else {
      setOnDataAddModalSelect(true);
      setOnSubtableDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // サブサブテーブルデータの登録結果（共通）
  const [onSubSubtableDataAddModalResult, setOnSubSubtableDataAddModalResult] =
    useState("");

  // 上位店一覧
  const [highRankCompanyList, setHighRankCompanyList] = useState<
    { id: number; high_rank_company_name: string }[]
  >([]);
  const [highRankCompanyNameList, setHighRankCompanyNameList] = useState([""]);
  // 上位店一覧取得
  async function getHighRankCompanyList() {
    const fetchData = await getSerchHighRankCompanys();
    if (fetchData === null) {
      setHighRankCompanyList([]);
    } else if (fetchData) {
      setHighRankCompanyList(
        fetchData.highRankCompanys as {
          id: number;
          high_rank_company_name: string;
        }[],
      );
      let highRankCompanyNameList = [""];
      fetchData.highRankCompanys.map(
        (company: { id: number; high_rank_company_name: string }) => {
          if (
            !highRankCompanyNameList.includes(company.high_rank_company_name)
          ) {
            highRankCompanyNameList.push(company.high_rank_company_name);
          }
        },
      );
      setHighRankCompanyNameList(highRankCompanyNameList);
    }
  }

  // カテゴリ一覧
  const [categoryList, setCategoryList] = useState<
    { id: number; category_name: string }[]
  >([]);
  const [categoryNameList, setCategoryNameList] = useState([""]);
  async function getCategoryList() {
    const fetchData = await getSerchCategorys();
    if (fetchData === null) {
      setCategoryList([]);
    } else if (fetchData) {
      setCategoryList(
        fetchData.categorys as {
          id: number;
          category_name: string;
        }[],
      );
      let categoryNameList = [""];
      fetchData.categorys.map(
        (company: { id: number; category_name: string }) => {
          if (!categoryNameList.includes(company.category_name)) {
            categoryNameList.push(company.category_name);
          }
        },
      );
      setCategoryNameList(categoryNameList);
    }
  }

  // パートナー一覧
  const [companyList, setCampanyList] = useState<
    { id: number; sale_company_name: string }[]
  >([]);
  const [companyNameList, setCampanyNameList] = useState([""]);
  // パートナー一覧取得
  async function getSaleCompanysList() {
    const fetchData = await getSerchSaleCompanys();
    if (fetchData === null) {
      setCampanyList([]);
    } else if (fetchData) {
      setCampanyList(
        fetchData.saleCompanys as { id: number; sale_company_name: string }[],
      );
      let companyNameList = [""];
      fetchData.saleCompanys.map(
        (company: { id: number; sale_company_name: string }) => {
          if (!companyNameList.includes(company.sale_company_name)) {
            companyNameList.push(company.sale_company_name);
          }
        },
      );
      setCampanyNameList(companyNameList);
    }
  }

  // 商材一覧
  const [productList, setProductList] = useState<
    { id: number; high_rank_company_id: number; product_name: string }[]
  >([]);
  const [productNameList, setProductNameList] = useState([""]);
  async function getProductList() {
    const fetchData = await getSerchProducts();
    if (fetchData === null) {
      setProductList([]);
    } else if (fetchData) {
      setProductList(
        fetchData.products as {
          id: number;
          high_rank_company_id: number;
          product_name: string;
        }[],
      );
      let productNameList = [""];
      fetchData.products.map(
        (company: {
          id: number;
          high_rank_company_id: number;
          product_name: string;
        }) => {
          if (!productNameList.includes(company.product_name)) {
            productNameList.push(company.product_name);
          }
        },
      );
      setProductNameList(productNameList);
    }
  }

  useEffect(() => {
    getSaleCompanysList();
    getHighRankCompanyList();
    getCategoryList();
    getProductList();
  }, []);

  // cmd-po_1168 SP排他: AI open時に検索を close
  useEffect(() => {
    if (aiChatOpen && isSmartPhone) setSerchOpen(false);
  }, [aiChatOpen, isSmartPhone]);
  const handleSetSerchOpen = (open: boolean) => {
    setSerchOpen(open);
    if (open && isSmartPhone) setAiChatOpenAtom(false);
  };

  return (
    <Box
      data-testid="screen-column-config-page"
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: "var(--sp-2, 8px)",
          alignItems: "stretch",
          flex: 1,
          minHeight: 0,
        }}
      >
        {detailView && dataDetail ? (
          /* ─── 詳細ページビュー ─── */
          <Box
            sx={{
              flex: 1,
              minWidth: 0,
              display: "flex",
              flexDirection: "column",
              minHeight: 0,
              maxHeight: "100%",
            }}
          >
            <Box
              data-testid="detail-header"
              sx={{
                display: "flex",
                alignItems: "center",
                mb: 2,
                flexWrap: "wrap",
                gap: 1,
                flexShrink: 0,
              }}
            >
              <IconButton
                size="small"
                onClick={closeDetailView}
                aria-label="一覧に戻る"
                sx={{ mr: 0.5 }}
              >
                <ArrowBackIcon fontSize="small" />
              </IconButton>
              <Typography
                variant="h6"
                sx={{ fontWeight: 700, fontSize: 20, color: "text.primary" }}
              >
                {dataDetail["screen_column_name"] as string}
              </Typography>
            </Box>
            <DataDetailTable
              editAuth={screenColumnConfigTableColumn.editAuth}
              dataColumn={screenColumnConfigTableColumn.dataColumn}
              subDataColumn={[]}
              dataDetail={dataDetail}
              setEditData={() => {}}
              dataDetailOption={[]}
              dataDetailOptionSelect={[]}
              dataDetailHistory={[]}
              detailTitle={screenColumnConfigTableColumn.detailTitle}
              getGroupList={() => {}}
              setSelectServiseInfo={() => {}}
              setSelectTossUpInfo={() => {}}
            />
          </Box>
        ) : (
          <>
            {(serchOpen || aiChatOpen) && isSmartPhone ? null : (
              <Box
                sx={{
                  flex: 1,
                  minWidth: 0,
                  display: "flex",
                  flexDirection: "column",
                  maxHeight: "100%",
                }}
              >
                <TableTopBar
                  serch={true}
                  serchOpen={serchOpen}
                  setSerchOpen={handleSetSerchOpen}
                  addDataNames={addDataNames}
                  addDataName={addDataName}
                  setAddDataName={setAddDataName}
                  addCSVDataNames={addCSVDataNames}
                  addCSVDataName={addCSVDataName}
                  setAddCSVDataName={setAddCSVDataName}
                  getXLSXDataNames={getXLSXDataNames}
                  getXLSXDataName={getXLSXDataName}
                  setGetXLSXDataName={setGetXLSXDataName}
                  editDatasNames={editDatasNames}
                  editDatasName={editDatasName}
                  setEditDatasName={setEditDatasName}
                  editIDs={[]}
                  columnSettingOpen={false}
                  openColumnSettingWindow={() => {}}
                    totalCount={totalCount}
                  onReload={() => getTableData(false)}
                />
                <ConstTable
                  emptyState={
                    <EmptyState
                      isSearchActive={Object.keys(serchString).some(
                        (k) =>
                          (serchString as Record<string, string>)[k] !==
                          (serchColumn as Record<string, string>)[k],
                      )}
                      onClearSearch={() => {
                        setSerchString(serchColumn);
                        setSerchStringView(serchColumn);
                      }}
                      canAdd={addDataNames.includes("システム項目設定登録")}
                      onAdd={() => setAddDataName("システム項目設定登録")}
                      entityLabel="表示項目設定"
                    />
                  }
                  getTableData={getTableData}
                  tableType={"main"}
                  serch={true}
                  setSerchOpen={handleSetSerchOpen}
                  serchOpen={serchOpen}
                  tableColumn={screenColumnConfigTableColumn}
                  dataColumn={[]}
                  rows={fetchData}
                  displayNumber={displayNumber}
                  setDisplayNumber={setDisplayNumber}
                  displayNumbers={displayNumbers}
                  pageNumber={pageNumber}
                  setPageNumber={setPageNumber}
                  maxPageNumber={maxPageNumber}
                  totalCount={totalCount}
                  getDataDetail={getDataDetail}
                  getSubTableName={getSubTableName}
                  setGetSubTableName={setGetSubTableName}
                  getSubTableDetail={getSubTableDetail}
                  setGetSubTableDetail={setGetSubTableDetail}
                  setGetSubTableAdd={setGetSubTableAdd}
                  setGetSubTableEditDirect={() => {}}
                  getSubSubTableName={getSubSubTableName}
                  setGetSubSubTableName={setGetSubSubTableName}
                  getSubSubTableDetail={{ name: "", key: {}, dataDetail: null }}
                  setGetSubSubTableDetail={() => {}}
                  setGetSubSubTableAdd={setGetSubSubTableAdd}
                  setGetSubSubTableEditDirect={() => {}}
                  tableTitle={screenColumnConfigTableColumn.title}
                  switchTableCheckBox={() => {}}
                  allCheckFlg={false}
                  switchAllTableCheckBox={() => {}}
                  editIDs={[]}
                  setEditIDs={() => {}}
                  setEditDatasName={setEditDatasName}
                  setTableOriginalFunc={setTableOriginalFunc}
                  sortColumn={sortColumn}
                  setSortColumn={setSortColumn}
                />
              </Box>
            )}
            {serchOpen ? (
              <SerchSideBar
                setSerchOpen={handleSetSerchOpen}
                tableColumn={screenColumnConfigTableColumn}
                dataColumn={[]}
                firstYear={firstYear}
                thisYear={thisYear}
                serchColumn={serchColumn}
                setSerchString={setSerchString}
                companyNameList={companyNameList}
                companyGroupNameList={[]}
                highRankCompanyNameList={highRankCompanyNameList}
                categoryNameList={categoryNameList}
                productNameList={productNameList}
                accountSaleNameList={[]}
                accountStaffNameList={[]}
                serchStringView={serchStringView}
                setSerchStringView={setSerchStringView}
              />
            ) : null}
          </>
        )}
      </Box>
      <DataAddModal
        onModal={onAddModal}
        swCloseModal={() => {
          setAddModal(false);
          setAddDataName("");
        }}
        addTitle={screenColumnConfigTableColumn.addTitle}
        dataColumn={screenColumnConfigTableColumn.dataColumn}
        subDataColumn={[]}
        postAddData={postAddData}
        addData={addData}
        setAddData={setAddData}
        companyList={[]}
        highRankCompanyList={highRankCompanyList}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={[]}
        categoryList={categoryList}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModalResult
        onModal={onDataAddModalResult !== ""}
        swCloseModal={() => {
          setOnDataAddModalResult("");
          setAddDataName("");
        }}
        addModalTitle={"新規作成"}
        onDataAddModalResult={onDataAddModalResult}
      />
      <DataAddModal
        onModal={onDataAddModalLoginCompany}
        swCloseModal={() => {
          setOnDataAddModalLoginCompany(false);
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addTitle={screenColumnConfigTableColumn.subTable[0].subTableAddTitle}
        dataColumn={[]}
        subDataColumn={screenColumnConfigTableColumn.subTable[0].subDataColumn}
        postAddData={postAddDataLoginCompany}
        addData={addDataLoginCompany}
        setAddData={setAddDataLoginCompany}
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={[]}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModal
        onModal={onDataAddModalSelect}
        swCloseModal={() => {
          setOnDataAddModalSelect(false);
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addTitle={screenColumnConfigTableColumn.subTable[1].subTableAddTitle}
        dataColumn={[]}
        subDataColumn={screenColumnConfigTableColumn.subTable[1].subDataColumn}
        postAddData={postAddDataSelect}
        addData={addDataSelect}
        setAddData={setAddDataSelect}
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={[]}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModalResult
        onModal={onSubtableDataAddModalResult !== ""}
        swCloseModal={() => {
          setOnSubtableDataAddModalResult("");
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addModalTitle={"新規作成"}
        onDataAddModalResult={onSubtableDataAddModalResult}
      />
      <DataAddModalResult
        onModal={onSubSubtableDataAddModalResult !== ""}
        swCloseModal={() => {
          setOnSubSubtableDataAddModalResult("");
          setGetSubSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addModalTitle={"新規作成"}
        onDataAddModalResult={onSubSubtableDataAddModalResult}
      />
      <DataDeleteModal
        onModal={
          deleteDataInf.status !== null && deleteDataInf.status !== "loading"
        }
        swCloseModal={() => {
          setDeleteDataInf({
            status: null,
            key: {},
            message: "",
          });
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        deleteDataInf={deleteDataInf}
        setDeleteDataInf={setDeleteDataInf}
        deleteData={deleteData}
        labels={{
          title: "システム項目削除",
          confirmBody: (
            <Alert severity="info">
              システム項目の削除を行います。
              <br />
              項目を削除しても、登録したデータには影響はありません。
              <br />
              削除後、同一項目名で登録を行えば、データの再表示が可能です。
            </Alert>
          ),
          confirmButtonLabel: "システム項目削除",
          successMessage: "システム項目の削除に成功しました。",
        }}
      />
    </Box>
  );
}

export default ScreenColumnConfig;
